// src/app/routes/routes.tsx
import { RouteObject } from 'react-router-dom';
import { HomePage } from '@/pages/HomePage';
import { LoginPage } from '@/pages/LoginPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { QuestionnairePage } from '@/pages/QuestionnairePage';
import { ProtectedRoute } from './ProtectedRoute';
import { MainLayout } from '@/layouts/MainLayout';
import {ContactsPage} from "@/pages/ContactsPage/ContactsPage";
import {FAQPage} from "@/pages/FAQPage/FAQPage";
import {InformationPage} from "@/pages/InformationPage/InformationPage";
import {ContactOfferPage} from "@/pages/ContactOfferPage/ContactOfferPage";
import {PrivacyPolicyPage} from "@/pages/PrivacyPolicyPage/PrivacyPolicyPage";
import {ForgetPasswordPage} from "@/pages/ForgetPasswordPage/ForgetPasswordPage";
import {CheckEmailPage} from "@/pages/CheckEmailPage/CheckEmailPage";
import {ResetPasswordPage} from "@/pages/ResetPasswordPage/ResetPasswordPage";
import {PasswordUpdatedPage} from "@/pages/PasswordUpdatedPage/PasswordUpdatedPage";
import {RegisterPage} from "@/pages/RegisterPage/RegisterPage";
import {RegistrationSuccessPage} from "@/pages/RegistrationSuccessPage/RegistrationSuccessPage";
import {AccountPage} from "@/pages/AccountPage/AccountPage";
import {CheckupRoute} from "@/app/routes/CheckupRoute";
import {HealthRecommendationsPage} from "@/pages/HealthRecommendationsSection/HealthRecommendationsPage";
import {VitaminProgramPage} from "@/pages/VitaminProgramPage/VitaminProgramPage";
import {ResultsPage} from "@/pages/ResultsPage/ResultsPage";
import {DashboardTabs} from "@/pages/DashboardTabs/DashboardTabs";
import {TestResultLoader} from "@/features/questionnaire/ui/TestResultLoader/TestResultLoader";

export const routes: RouteObject[] = [
    {
        element: <MainLayout />, // Header будет применяться ко всем вложенным
        children: [
            { path: '/', element: <HomePage /> },
            { path: '/contacts', element: <ContactsPage /> },
            { path: '/login', element: <LoginPage /> },
            { path: '/faq', element: <FAQPage /> },
            { path: '/information-sources', element: <InformationPage /> },
            { path: '/contract-offer', element: <ContactOfferPage /> },
            { path: '/privacy-policy', element: <PrivacyPolicyPage /> },
            { path: '/password-reset', element: <ForgetPasswordPage /> },
            { path: '/check-email', element: <CheckEmailPage /> },
            { path: '/reset-password', element: <ResetPasswordPage /> },
            { path: '/password-updated', element: <PasswordUpdatedPage /> },
            { path: '/registration', element: <RegisterPage /> },
            { path: '/registration-success', element: <RegistrationSuccessPage /> },
            { path: '/test', element: <TestResultLoader /> },
            {
                element: <ProtectedRoute />,
                children: [
                    { path: '/dashboard', element: <DashboardPage /> },
                    { path: '/checkup', element: <CheckupRoute /> },
                    { path: '/questionnaire', element: <QuestionnairePage /> },
                    { path: '/account', element: <AccountPage /> },
                    {
                        path: '/my-health',
                        element: (
                            <DashboardTabs
                            />
                        ),
                    },
                ],
            },
        ],
    },
];
